import { JsDocRecord, StaticComponentAnalyzerResult } from "./types.js"

export async function analyzeJsDoc(
  staticComponentsResult: StaticComponentAnalyzerResult,
): Promise<Record<string, JsDocRecord>> {
  return staticComponentsResult.jsdocByComponentKey
}
